import { action, computed, makeObservable, observable } from 'mobx'

import { BaseStore } from '@new/__global/components/FastTapeChart/__types'
import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'

import { ExtendedColumnConfigProps, FastTapeChartExtendedColumnKey } from './ExtendedColumns.types'
import { extendedColumns, getExtendedColumnWidth } from './ExtendedColumns.utils'

export class ExtendedColumnsStore {
  constructor(
    private getFilterStore: () => BaseStore['filterStore'],
    private getArrivalsModeStore: () => BaseStore['arrivalModeStore'],
  ) {
    makeObservable<ExtendedColumnsStore, 'columns'>(this, {
      hoveredBookingId: observable,
      columns: computed,
      activeColumns: computed,
      isSortableExtendedColumnsActive: computed,
      isExtendedColumnsActive: computed,
      extendedColumnsWidth: computed,
      setHoverBookingById: action.bound,
    })
  }

  get filterStore() {
    return this.getFilterStore()
  }

  get arrivalModeStore() {
    return this.getArrivalsModeStore()
  }

  hoveredBookingId?: string

  private get columns(): ExtendedColumnConfigProps[] {
    void [this.filterStore.extendedColumnsView]

    const activeExtendedColumns =
      extendedColumns
        .filter(column => Object.keys(FastTapeChartExtendedColumnKey).includes(column.columnKey))
        .filter(extendedColumn =>
          (this.filterStore.extendedColumnsView ?? []).includes(
            extendedColumn.columnKey as ExtendedColumnKey,
          ),
        ) ?? []

    return activeExtendedColumns ?? []
  }

  get activeColumns(): ExtendedColumnConfigProps[] {
    return this.columns.concat(this.arrivalModeStore?.arrivalsModeColumns as any)
  }

  get isSortableExtendedColumnsActive(): boolean {
    return !!this.columns.length
  }

  get isExtendedColumnsActive(): boolean {
    return !!this.activeColumns.length
  }

  get extendedColumnsWidth(): number {
    return getExtendedColumnWidth(this.activeColumns)
  }

  setHoverBookingById(bookingId?: string) {
    this.hoveredBookingId = bookingId
  }
}
